import LandingPage from 'components/LandingPage/LandingPage';

const IndexPage = () => {
  return <LandingPage />;
};

IndexPage.noHeaderLayout = true;
export default IndexPage;
